import { inject, Injectable } from '@angular/core';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { Observable, of } from 'rxjs';
import { Elevation } from '../models/elevation.models';

import { ModelElevation } from '../models/model-elevations';

@Injectable({
  providedIn: 'root'
})
export class ElevationService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  createElevation(id: string, elevation: any): Observable<unknown> {
    return this.#http.postData(
      `${this.baseUrl}/Model/${id}/elevations`,
      { showLoader: true, showMessage: true },
      elevation
    );
  }

  updateElevation(id: string, elevation: any): Observable<unknown> {
    return this.#http.putData(`${this.baseUrl}/Model/elevations/${id}`, elevation, {
      showLoader: true,
      showMessage: true
    });
  }

  getElevationByModelId(id: string): Observable<unknown> {
    return this.#http.getData(`${this.baseUrl}/Model/${id}/elevations?includingInActive=false`, {
      showLoader: true,
      showMessage: false
    });
  }

  readElevationByModelId(id: string): Observable<Elevation[]> {
    return this.#http.getData(`${this.baseUrl}/Model/${id}/elevations?includingInActive=false`, {
      showLoader: true,
      showMessage: false
    });
  }

  getElevationById(id: string): Observable<unknown> {
    return this.#http.getData(`${this.baseUrl}/Model/elevations/${id}`, { showLoader: true, showMessage: false });
  }

  getElevations(id: string): Observable<unknown> {
    return this.#http.getData(`${this.baseUrl}/Model/${id}/elevations`, { showLoader: true, showMessage: false });
  }

  getModels(): Observable<unknown> {
    return this.#http.getData(`${this.baseUrl}/Model`, { showLoader: true, showMessage: false });
  }

  toggleElevation(id: string): Observable<unknown> {
    return this.#http.putData(`${this.baseUrl}/Model/elevations/${id}/toggle`, true, {
      showLoader: true,
      showMessage: false
    });
  }

  getLotModelElevations(lotId: string, modelId: string): Observable<Elevation[]> {
    return this.#http.getData<Elevation[]>(`${this.baseUrl}/Lot/${lotId}/model/${modelId}/elevations`, {
      showLoader: true,
      showMessage: false
    });
  }

  assignModelsToProject(projectId: string, modelElevations: ModelElevation | null): Observable<unknown> {
    if (!modelElevations) {
      return of([]);
    }
    return this.#http.postData(
      `${this.baseUrl}/Project/${projectId}/model`,
      { showLoader: true, showMessage: true, message: 'Models assigned to project successfully' },
      modelElevations
    );
  }
}
